module.exports = __webpack_public_path__ + "img/spa.519b7083.svg";